import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetches the bulk onboarding list with server-side pagination.
 * POST api/BulkUpload/bulk-onboarding-list
 */
export const fetchBulkOnboardingListAction = async ({
  searchValue = null,
  pageNumber = 1,
  pageSize = 10,
} = {}) => {
  try {
    const response = await apiClient.post(ATP_API_URL.BULK_ONBOARDING_LIST, {
      searchValue: searchValue || null,
      pageNumber,
      pageSize,
    });

    if (response?.status === 200 && response.data) {
      const {
        isSuccess,
        onboardingBulkUploadResponseList,
        totalRecords,
        pageNumber: pg,
      } = response.data;
      if (isSuccess) {
        return {
          success: true,
          data: onboardingBulkUploadResponseList || [],
          totalRecords: totalRecords || 0,
          pageNumber: pg || pageNumber,
        };
      }
      return {
        success: false,
        message: response.data.message || "Failed to fetch list",
        data: [],
        totalRecords: 0,
      };
    }
    return {
      success: false,
      message: "Failed to fetch list",
      data: [],
      totalRecords: 0,
    };
  } catch (error) {
    console.error("[BulkOnboardingList] error:", error);
    return {
      success: false,
      message: error.message || "Failed to fetch list",
      data: [],
      totalRecords: 0,
    };
  }
};
